import { render, staticRenderFns } from "./MemberProfileForm.vue?vue&type=template&id=10c54c66&scoped=true"
import script from "./MemberProfileForm.vue?vue&type=script&lang=js"
export * from "./MemberProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c54c66",
  null
  
)

export default component.exports